import styles from "./AlertDelete.module.css"
import { TriangleAlert } from "lucide-react"
import { toast } from "react-toastify";

function AlertDelete({ setIsOpen, entity, func }) {
    return (
        <div className={styles.container}>
            <div className={styles.form}>
                <div className={styles.containerOne}>
                    <div className={styles.icon}>
                        <TriangleAlert size={24} color="#ef4343" />
                    </div>
                    <p>O Registro de ID {entity.id} será excluído permanentemente. Esta ação não poderá ser desfeita.</p>
                </div>
                <div className={styles.containerButtons}>
                    <button className={styles.nao} onClick={() => setIsOpen(false)}>Não</button>
                    <button className={styles.sim} onClick={async () => {
                        await func(entity.id)
                            .then(() => {
                                setIsOpen(false);
                                toast.success("Registro excluído!");
                            })
                            .catch((error) => {
                                if (error.response.status === 401) {
                                    return toast.error("Não autorizado!");
                                } else if (error.response.status != 200) {
                                    return toast.error("Erro! Verificar com suporte");
                                }
                            })
                    }}>
                        Sim
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AlertDelete